import { Stack } from "@mui/material";
import React from "react";
import { TabMainTitle } from "../../Components/View/Typography/title";
import GeneralTable from "../../Components/View/Table/TableGeneral";
import DetailTabs from "../../Components/View/Tab/DetailTab/DetailTab";

export default function DetailResult({ code }) {
    
    return (
        <Stack spacing={3}>
            
            <DetailTabs code={code} />
        </Stack>
    )
}

